export const CommissionRules = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.05469 10.8545H12.6547"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.74414 8.23608H13.9623"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5996 18.5454L18.2178 15.2727"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9091 12C19.6186 12 21.8182 14.1995 21.8182 16.909C21.8182 19.6185 19.6186 21.8181 16.9091 21.8181C14.1996 21.8181 12 19.6185 12 16.909C12 14.1995 14.1996 12 16.9091 12Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.79983 16.9091H3.49076C2.7678 16.9091 2.18164 17.4952 2.18164 18.2181V3.49089C2.18164 3.14367 2.31946 2.81083 2.5652 2.56538C2.81065 2.3196 3.14354 2.18182 3.49076 2.18182H4.79983V16.9091Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 16.909H3.49072C3.14349 16.909 2.81065 17.0468 2.5652 17.2926C2.31942 17.538 2.18164 17.8709 2.18164 18.2181C2.18164 18.9411 2.7678 19.5272 3.49072 19.5272H12.7565"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0008 16.9091H4.80078V2.18181H16.9098V12H16.9092C14.1984 12 12.0008 14.1976 12.0008 16.9084V16.9091Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2734 15.2842C15.2757 15.2842 15.2768 15.2834 15.2773 15.2832C15.2783 15.2828 15.2798 15.2817 15.2812 15.2803C15.2826 15.2789 15.2828 15.2772 15.2832 15.2764C15.2834 15.2759 15.2842 15.2749 15.2842 15.2725C15.2842 15.2702 15.2834 15.269 15.2832 15.2686C15.2828 15.2677 15.2826 15.266 15.2812 15.2646C15.2799 15.2633 15.2782 15.2631 15.2773 15.2627C15.2768 15.2625 15.2757 15.2617 15.2734 15.2617C15.271 15.2617 15.2701 15.2625 15.2695 15.2627C15.2687 15.2631 15.267 15.2633 15.2656 15.2646C15.2642 15.2661 15.2631 15.2676 15.2627 15.2686C15.2625 15.269 15.2617 15.2701 15.2617 15.2725C15.2617 15.2746 15.2625 15.2758 15.2627 15.2764C15.2631 15.2773 15.2641 15.2788 15.2656 15.2803C15.2671 15.2818 15.2686 15.2828 15.2695 15.2832C15.2701 15.2834 15.2713 15.2842 15.2734 15.2842Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M18.5449 18.5569C18.5472 18.5569 18.5483 18.5561 18.5488 18.5559C18.5497 18.5555 18.5513 18.5544 18.5527 18.553C18.5541 18.5516 18.5543 18.5499 18.5547 18.5491C18.5549 18.5486 18.5557 18.5476 18.5557 18.5452C18.5556 18.5429 18.5549 18.5417 18.5547 18.5413C18.5542 18.5404 18.554 18.5387 18.5527 18.5374C18.5514 18.536 18.5497 18.5358 18.5488 18.5354C18.5483 18.5352 18.5472 18.5344 18.5449 18.5344C18.5425 18.5344 18.5415 18.5352 18.541 18.5354C18.5402 18.5358 18.5385 18.536 18.5371 18.5374C18.5357 18.5388 18.5346 18.5404 18.5342 18.5413C18.534 18.5417 18.5332 18.5429 18.5332 18.5452C18.5332 18.5473 18.534 18.5485 18.5342 18.5491C18.5346 18.55 18.5356 18.5515 18.5371 18.553C18.5386 18.5545 18.5401 18.5555 18.541 18.5559C18.5416 18.5561 18.5428 18.5569 18.5449 18.5569Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  );
};
